import React from 'react';
import AdventureBearImage from '@/assets/app/images/common/bottom/adventure-bear.png';
import AppButton from '@/shared/components/ui/new/AppButton';

interface RetryQuizModalProps {
  onConfirm: (isRetry?: boolean) => void;
  onCancel: () => void;
  closeSheet: () => void;
  completedData: QuizSessionResult;
}

export const QuizResultSheet: React.FC<RetryQuizModalProps> = ({
  onConfirm,
  onCancel,
  closeSheet,
  completedData,
}) => {
  const retryQuiz = () => {
    closeSheet();
    onConfirm(true);
  };
  const results = [true, false, false, true, true];
  const correctCount = results.filter(isCorrect => isCorrect).length;
  const incorrectCount = results.length - correctCount;
  return (
    <div className="max-w-md mx-auto px-2 bg-white w-full font-sans quiz-result">
      {/* 타이틀 영역 */}
      {/* <div className="text-[22px] font-extrabold text-center text-gray-900 mb-2">결과 확인</div> */}

      {/* 구분선 */}
      {/* <hr className="border-t-[1.5px] border-gray-300 mb-8" /> */}

      {/* 정답/오답 요약 */}
      <div className="flex justify-center items-center gap-5 mb-6 text-[17px] font-bold">
        <span className="text-[20px] text-blue-500 tracking-tight f-one-pop">
          정답 {completedData.correctAnswers}개
        </span>
        <span className="text-[20px] text-red-400 tracking-tight f-one-pop">
          오답 {completedData.wrongAnswers}개
        </span>
      </div>

      {/* 결과 그리드 (문항 번호 및 O/X) */}
      <div className="flex justify-between gap-[4px]">
        {completedData.answerDetails.map((answer, index) => (
          <div key={index} className="flex flex-col gap-[4px] flex-1">
            {/* 문항 번호 박스 */}
            <div
              className="flex items-center justify-center py-3.5 bg-[#BFE7F2]"
              style={{
                borderRadius: `${index === 0 ? '15px' : '6px'}  ${index === completedData.answerDetails.length - 1 ? '15px' : '6px'} 6px 6px`,
              }}
            >
              <span className="text-xl font-bold text-gray-900">{index + 1}</span>
            </div>

            {/* 채점 결과 박스 (O/X 아이콘) */}
            <div
              className="flex items-center justify-center py-3.5 bg-[#E6F5FE] h-[52px]"
              style={{
                borderRadius: `6px 6px ${index === completedData.answerDetails.length - 1 ? '15px' : '6px'} ${index === 0 ? '15px' : '8px'}`,
              }}
            >
              {answer.isCorrect ? (
                // O 아이콘
                <div
                  className="icon-css-o"
                  style={{ width: 26, height: 26, border: '6px solid #0094ef' }}
                ></div>
              ) : (
                // X 아이콘
                <div className="icon-css-x" style={{ width: 26, height: 26 }}></div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* 메시지 */}
      <h2
        className="text-xl f-black font-bold text-center m-0 f-one-pop mt-8 mb-5"
        style={{ fontSize: 32 }}
      >
        모험을 다시 시작할까요?
      </h2>
      <div className="text-center" style={{ color: '#828282', fontSize: 11 }}>
        놓친 문제를 풀고 부족한 포인트를 채울 수 있어요!
        <br />
        지금 종료하면 이 챕터는 다시 도전할 수 없어요.
      </div>

      <div className="button-group mt-5">
        <AppButton className="f-one-pop text-[20px]" onConfirm={retryQuiz} message="다시 하기" />
        <AppButton
          className="f-one-pop text-[20px]"
          backgroundColor="#D4D4D4"
          boxShadowColor="#B7B7B7"
          style={{
            marginTop: 10,
          }}
          onConfirm={onCancel}
          message="모험 종료"
        />
      </div>
    </div>
  );
};
